<div class="recommended-hotels">
  <h2 class="recommended-hotels__title" i18n="@@recommended__views">
    Las personas que vieron {{ reference.name }} también consultaron estos alojamientos
  </h2>
  <div class="recommended-hotels__hotels-container">
    @if (hotels.length > 0) {
      <mb-carousel-custom [showButtons]="!isMobile" [showDots]="false">
        @for (hotel of hotels; track hotel) {
          <mb-carousel-item>
            <div class="container-card-recommended">
              <mb-recommended-card
                class="recommended-hotels__hotels-container__hotel"
                [image]="getHotelImage(hotel.images)"
                [stars]="hotel.stars"
                [rating]="hotel.rating"
                [pricePerNigth]="query?.queryParams?.priceBy === 'NIGHT' || isLanding"
                [includedTaxes]="getTaxes(hotel)"
                [name]="hotel.name"
              >
                <div class="recommended-hotels__hotels-container__hotel__content__price__price-amount">
                  @if (!isAlliance) {
                    <span
                      class="recommended-hotels__hotels-container__hotel__content__price__price-amount__currency"
                      >$&nbsp;</span
                    >
                    <span
                      class="recommended-hotels__hotels-container__hotel__content__price__price-amount__price"
                      >{{
                        (query?.queryParams?.priceBy === 'TOTAL'
                          ? setTaxesTotal(hotel)
                          : setTaxes(hotel)
                        ) | Currency
                      }}</span
                    >
                  } @else {
                    <am-rewards-pricing [price]="getSuperClubPrice(hotel)"></am-rewards-pricing>
                  }
                </div>
              </mb-recommended-card>
            </div>
          </mb-carousel-item>
        }
      </mb-carousel-custom>
    }
  </div>
</div>
